import { render, staticRenderFns } from "./Conta.vue?vue&type=template&id=46f60551&scoped=true&"
import script from "./Conta.vue?vue&type=script&lang=js&"
export * from "./Conta.vue?vue&type=script&lang=js&"
import style0 from "./Conta.vue?vue&type=style&index=0&id=46f60551&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f60551",
  null
  
)

export default component.exports